import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		listBuildings_rowContainer: {
			display: 'flex',
			width: '100%',
			flexDirection: 'column',
		},
		listBuildings_rowBody: {
			display: 'flex',
			[theme.breakpoints.down(BreakpointWidth.X_LARGE)]: {
				flexWrap: 'wrap',
			},
		},
		listBuildings_addressLabel: {
			height: '100%',
			borderRadius: theme.shape.borderRadius,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-around',
			color: theme.palette.info.main,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(2, 0),
			},
		},
	});
});

export default useStyles;
